import * as Highcharts from 'highcharts';

export const options: Highcharts.Options = {
  credits: {
    enabled: false
  },
  chart: {
    type: 'spline',
    className: 'stock-chart',
    backgroundColor: 'transparent',
    spacing: [12, 12, 16, 12],
    plotBorderWidth: 0,
    animation: false,
    zooming: {
      type: 'xy'
    }
  },
  xAxis: {
    type: 'datetime',
    crosshair: true,
    ordinal: false,
    events: {}
  },
  yAxis: [],
  legend: {
    enabled: true,
    verticalAlign: 'top'
  },
  tooltip: {
    shared: true,
    split: false
  },
  plotOptions: {
    series: {
      boostThreshold: 1000,
      dataGrouping: {
        enabled: true
      },
      marker: {
        lineWidth: 1
      }
    },
    column: {
      borderWidth: 0,
      groupPadding: 0.1,
      pointPadding: 0.05
    }
  },
  rangeSelector: {
    enabled: true,
    selected: 5,
    allButtonsEnabled: false,
    inputDateFormat: '%d-%m-%Y',
    inputEditDateFormat: '%d-%m-%Y',
    buttons: [
      { type: 'month', count: 1, text: '1m' },
      { type: 'month', count: 3, text: '3m' },
      { type: 'month', count: 6, text: '6m' },
      { type: 'ytd', text: 'YTD' },
      { type: 'year', count: 1, text: '1y' },
      { type: 'all', text: 'All' }
    ]
  },
  navigator: {
    enabled: true,
    height: 40,
    yAxis: {
      visible: false,
      labels: {
        enabled: false
      }
    }
  },
  boost: {
    useGPUTranslations: true,
    usePreallocated: true
  },
  scrollbar: {
    enabled: true
  },
  exporting: {
    enabled: true,
    filename: 'chart',
    csv: {
      itemDelimiter: ';'
    },
    buttons: {
      contextButton: {
        enabled: true,
        align: 'right',
        verticalAlign: 'top',
        symbol: 'menu',
        menuItems: [
          'printChart',
          'downloadJPEG',
          'downloadSVG',
          'downloadCSV',
          'downloadXLS',
          'viewFullscreen'
        ]
      }
    }
  }
};
